export default (fetchMore, q) => {
  return (page, limit) => {
    fetchMore({
      variables: {
        limit,
        offset: page ? limit * (page - 1) : 0,
        q,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;
        return fetchMoreResult;
      },
    });
  };
};
